module.exports = __webpack_public_path__ + "static/media/Bulldog448_3c.0930ce48.svg";